// TD.tsx
import { cn } from "helpers/classNames";
import React from "react";

export interface TDProps extends React.TdHTMLAttributes<HTMLTableCellElement> {}

const TD: React.FC<TDProps> = (props) => {
  return (
    <td
      {...props}
      className={cn(
        `whitespace-nowrap px-3 py-4 text-sm text-gray-800 ${props.className || ""}`,
      )}
    />
  );
};

export default TD;
